<template>
    <div>

        
        <div class="bg-white flex justify-between md:flex-row p-3 mb-5 rounded gap-3 md:gap-5">
            <router-link :to="{ name: 'publicationLiked' }" class="text-base font-medium cursor-pointer text-[#828282]">
                {{ $t('nav.publicationLiked') }}
            </router-link>

            <router-link to="/"
                class="text-base font-medium cursor-pointer text-main-color border border-x-0 border-t-0 border-[#409DBA] md:mb-0 md:mr-3">
                {{ $t('nav.foodLiked') }}</router-link>
            <router-link :to="{ name: 'mallLiked' }" class="text-base font-medium cursor-pointer text-[#828282] ">
                {{ $t('nav.mallLiked') }}</router-link>
            <router-link v-if="HABARLAR_ENABLED" :to="{ name: 'newsLiked' }" class="text-base font-medium cursor-pointer text-[#828282] ">
                {{ $t('nav.newsLiked') }}</router-link>
            <router-link :to="{ name: 'mediaLiked' }" class="text-base font-medium cursor-pointer text-[#828282] ">
                {{ $t('nav.mediaLiked') }}</router-link>
        </div>
        
    </div>
</template>

<script>
import { FEATURE_FLAGS } from '@/constants'

export default {
    name: 'profileHome',
    components: {
        
    },
    data(){
        return {
            loading: false,
            HABARLAR_ENABLED: FEATURE_FLAGS.HABARLAR
        }
    },
    methods: {

    },
    computed: {

    },
    created(){

    }
}

</script>